export default __webpack_public_path__ + "static/media/leiden.6ac366e2.svg";